import * as audio from './kernel/audio.js';

export {
    init,
}

const sounds = [
    { name: 'ui-pack', url: new URL('../sounds/ui-pack.aac', import.meta.url) },
    { name: 'dial-up-modem', url: new URL('../sounds/Dial_up_modem_noises.aac', import.meta.url) },
    { name: 'fan-loop', url: new URL('../sounds/fan-loop.wav', import.meta.url) },
    { name: 'rain', url: new URL('../sounds/RAIN_Heavy_loop_stereo_01.aac', import.meta.url) },
    { name: 'allo', url: new URL('../sounds/HZ_Allo.mp3', import.meta.url) },
    { name: 'vocal', url: new URL('../sounds/HZ_Vocal.mp3', import.meta.url) },
    { name: 'merci', url: new URL('../sounds/HZ_Merci.mp3', import.meta.url) },
];

function init() {
    setupMobileKeyboard();
    return loadSounds();
}

function loadSounds() {
    return Promise.all([
        ...sounds.map(sound => {
            return audio.buffers.load(sound.name, sound.url);
        }),
    ]).then(() => {
        if (DEVMODE) console.log('All sounds loaded');
    });
}

function setupMobileKeyboard() {
    // Trigger mobile keyboard on screen click
    const screenElement = document.querySelector('.screen');

    // Focus input on screen click, raising the keyboard
    screenElement.addEventListener('click', () => {
        const input = document.querySelector('.mobile-input');
        input.focus();
    });

    // Prevent hitting enter submitting the mobile form for input
    document.querySelector('form').addEventListener('keypress', e => e.preventDefault());
}